import { render, staticRenderFns } from "./BlockOutlined.vue?vue&type=template&id=735fdd06&"
import script from "./BlockOutlined.vue?vue&type=script&lang=js&"
export * from "./BlockOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports